module.exports = __webpack_public_path__ + "img/t7-4.90e7184e.svg";